import React from 'react';
import styled from 'styled-components';
import { theme } from '../theme';
import Reveal from './Reveal.jsx';
import ThreeShape from './ThreeShape.jsx';

const Section = styled.div`
  position: relative;
  padding: 90px 100px;
  border-top: 2px solid ${theme.border};
  background: ${theme.accent};
  color: ${theme.bg};
  overflow: hidden;
  @media (max-width: 900px) {
    padding: 60px 24px;
  }
`;
const GhostMark = styled.div`
  position: absolute;
  top: -60px;
  left: 60%;
  font-family: ${theme.fontDisplay};
  font-size: clamp(140px, 20vw, 260px);
  line-height: 1;
  color: rgba(17,17,20,0.08);
  pointer-events: none;
  user-select: none;
  animation: spinSlow 40s linear infinite;
`;
const Inner = styled.div`
  position: relative;
  z-index: 1;
`;
const Label = styled.div`
  font-family: ${theme.fontMono};
  font-size: 13px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 16px;
`;
const Headline = styled.div`
  font-family: ${theme.fontDisplay};
  font-size: clamp(38px, 6vw, 64px);
  text-transform: uppercase;
  line-height: 1;
  margin-bottom: 30px;
`;
const EmailButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 16px;
  background: ${theme.bg};
  color: ${theme.accent} !important;
  padding: 20px 30px;
  box-shadow: 8px 8px 0 rgba(17,17,20,0.35);
  transform: rotate(-1deg);
  font-family: ${theme.fontMono};
  font-size: 20px;
  font-weight: 700;
  flex-wrap: wrap;
`;
const Arrow = styled.span`
  font-family: ${theme.fontDisplay};
  font-size: 20px;
  display: inline-block;
  animation: bounce 1.4s ease-in-out infinite alternate;
`;
const ThreeLayer = styled.div`
  position: absolute;
  right: -40px;
  bottom: -60px;
  width: 340px;
  height: 340px;
  z-index: 0;
  pointer-events: none;
  opacity: 0.5;
  @media (max-width: 900px) {
    width: 220px;
    height: 220px;
    right: -30px;
    bottom: -30px;
  }
`;

export default function Contact() {
  return (
    <Section id="Contact">
      <GhostMark>?</GhostMark>
      <ThreeLayer>
        <ThreeShape color={theme.bg} shape="torusKnot" speed={0.7} />
      </ThreeLayer>
      <Reveal>
        <Inner>
          <Label>Contact</Label>
          <Headline>Let&apos;s Talk.</Headline>
          <EmailButton href="mailto:zaheerroberts4@gmail.com">
            <span>zaheerroberts4@gmail.com</span>
            <Arrow>&#8594;</Arrow>
          </EmailButton>
        </Inner>
      </Reveal>
    </Section>
  );
}
